module.exports = __webpack_public_path__ + "static/img/fr02.8876156.png";


//////////////////
// WEBPACK FOOTER
// ./static/img/index/fr02.png
// module id = kxoL
// module chunks = 18